// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"114":"buyer","182":"transfers","665":"voucher"}[chunkId] || chunkId) + "." + {"114":"31a8fa66","182":"9c9f9fd1","263":"c8adc0ff","665":"606cd014","702":"c67915f9","790":"a4c004de","947":"c07d3699"}[chunkId] + ".js";
};